<template>
  <section>
    <h4 class="form-card-header">{{ $t('registration.financial') }}</h4>
    <div class="form-card-form">
      <div>
        <label for="pi_source_of_income">{{ $t('registration.source_of_income') }}:<span
            class="text-danger">*</span></label>
        <multiselect id="pi_source_of_income" v-model="value"
                     placeholder="Та нэгээс дээш хариултыг сонгож болно" label="name" track-by="code" :options="options" :multiple="true"
                     :taggable="true" @tag="addTag" @input="onChange"></multiselect>
        <div class="error-message" v-show="v$.form.sourceOfIncome.$errors.length">
          <div v-show="!v$.form.sourceOfIncome.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
        <input type="hidden" name="source_of_income" :value="form.sourceOfIncome" />
      </div>

      <div>
        <label for="pi_salary">{{ $t('registration.salary') }}:<span class="text-danger">*</span></label>
        <select id="pi_salary"
                name="salary"
                v-model="v$.form.salary.$model"
                @blur="v$.form.salary.$touch()"
                class="form-select dropdown-color">
          <option v-for="item in FinancialCodes.salary" :key="item.value" :value="item.value">{{ item.name }}</option>
        </select>
        <div class="error-message" v-show="v$.form.salary.$errors.length">
          <div v-show="!v$.form.salary.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_trading_amount">{{ $t('registration.trading-amount') }}:<span class="text-danger">*</span></label>
        <select id="pi_trading_amount"
                name="trading_amount"
                v-model="v$.form.tradingAmount.$model"
                @blur="v$.form.tradingAmount.$touch()"
                class="form-select dropdown-color">
          <option v-for="item in FinancialCodes.trading_amount" :key="item.value" :value="item.value">{{ item.name }}</option>
        </select>
        <div class="error-message" v-show="v$.form.tradingAmount.$errors.length">
          <div v-show="!v$.form.tradingAmount.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i
            class="sr sr-chevron-left"></i>{{ $t('button.previous') }}
        </ic-button>
        <ic-button size="tn" type="button" variant="success" @click="next()" class="d-flex align-items-center ml-3">
          {{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>

  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import Multiselect from "vue-multiselect"
import {required} from '@vuelidate/validators'
import {FinancialCodes} from "../../constants";


export default {
  computed: {
    FinancialCodes() {
      return FinancialCodes
    }
  },
  components: {
    Multiselect,
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form: {
        sourceOfIncome: null,
        salary: null,
        tradingAmount: null
      },
      value: [],
      options: [
        {name: "Цалингийн орлого", code: 1},
        {name: "Бизнесийн орлого", code: 2},
        {name: "Гэрээний орлого", code: 3},
        {name: "Түрээсийн орлого", code: 4},
        {name: "Тэтгэвэр, тэтгэмж", code: 5},
        {name: "Хувьцаа, үнэт цаасны арилжаа", code: 6},
        {name: "Хөрөнгө оруулалтын орлого", code: 7},
        {name: "Өмч, хөрөнгийн борлуулалт", code: 8},
        {name: "Бусад орлого", code: 0},
      ]
    }
  },
  validations() {
    return {
      form: {
        sourceOfIncome: {required},
        salary: {required},
        tradingAmount: {required}
      }
    }
  },
  mounted() {
    this.fillOldData()
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${this.$('helper.please-fill-required-fields')}`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    onChange(value) {
      const json = value.reduce((acc, item) => {
        acc[item.code] = item.name;
        return acc;
      }, {});
      this.form.sourceOfIncome = Object.keys(json).length !== 0 ? JSON.stringify(json) : null
    },
    fillOldData() {
      if (!window.oldInputs) return;
      if (window.oldInputs['source_of_income']) {
        this.$set(this.form, 'source_of_income', window.oldInputs['source_of_income']);
      }
      if (window.oldInputs['salary']) {
        this.$set(this.form, 'salary', window.oldInputs['salary']);
      }
      if (window.oldInputs['trading_amount']) {
        this.$set(this.form, 'trading_amount', window.oldInputs['trading_amount']);
      }
    }
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>